import React, { Component } from 'react';
import LoginComponent from "../../components/Login";
import { loadScripts } from '../../utils.js';
import './csv.css';

class CsvPage extends Component {
  constructor() {
    super();
    this.state = {
      csv: '',
      entityAcro: ''
    };
    this.setLogin = this.setLogin.bind(this);
    this.loadJqueryTool = this.loadJqueryTool.bind(this);
    this.account = "mdv3";
    this.container = "exports-preview";
  }

  componentDidMount() {
    if(!this.state.csv) {
      this.setLogin().then(() => this.loadJqueryTool());
    } else {
      this.loadJqueryTool();
    }
  }

  componentWillUnmount() {
    // @TODO beware of memory leaks...
  }

  loadJqueryTool () {
    // @TEMP original prototype tool was developed in jQuery
    const parent = document.getElementsByClassName('csv-page')[0];
    loadScripts([
      '/jquery/jquery.csvtojson.min.js',
      '/jquery/jquery.csv.js'
    ], parent, () => {
      const { csv, entityAcro } = this.state;
      // jQuery is global via /public/index.html
      // eslint-disable-next-line
      window.$('.csv-page').mdCsv({ csv, entityAcro });
    });
  }

  async setLogin() {
    const { BlobServiceClient } = await import(/* webpackChunkName: "@azure/storage-blob" */ '@azure/storage-blob');

    const defaultAzureCredential = this.props.defaultAzureCredential;

    const blobServiceClient = new BlobServiceClient(
      `https://${this.account}.blob.core.windows.net`,
      defaultAzureCredential
    );
    const containerClient = blobServiceClient.getContainerClient(this.container);
    const fileList = [];
    let iterator = containerClient.listBlobsFlat();
    let blobItem = await iterator.next();
    while (!blobItem.done) {
      fileList.push(blobItem);
      blobItem = await iterator.next();
    }
    const metaList = fileList.filter(({value}) => /content/.test(value.name)).map(({value}) => {
      const blockBlobClient = containerClient.getBlockBlobClient(value.name);
      return blockBlobClient.getProperties().then(p => {
        const { metadata } = p;
        return {
          ...value,
          metadata,
          blockBlobClient
        }
      });
    });
    const allBlobMeta = await Promise.all(metaList);
    const { activeEntity } = this.props.location && this.props.location.state;
    const {acro: entityAcro} = !!activeEntity ? this.props.entities.find(({uuid}) => uuid === activeEntity) : { acro: 'dar' };
    const selectedEntityFiles = allBlobMeta.filter(({metadata}) => metadata.entity === entityAcro || metadata.entityuuid === activeEntity);
    if (selectedEntityFiles.length > 0){
      const { blockBlobClient } = selectedEntityFiles.sort((a,b) => a.properties.lastModified < b.properties.lastModified ? 1 : -1)[0];
      const downloadBlockBlobResponse = await blockBlobClient.download(0);
      const blob = await downloadBlockBlobResponse.blobBody;
      const csv = await blob.text();
      this.setState({ csv, entityAcro });
    }
  }

  render() {
    return (
      <div className='csv-page' />
    );
  }
}

export default ({location, data}) => {
  return <LoginComponent>{({ defaultAzureCredential }) => (<CsvPage defaultAzureCredential={defaultAzureCredential} location={location} entities={JSON.parse(data.baseline.edges[0].node.childRawCode.content)} />)}</LoginComponent>
}

export const query = graphql`
{
  patches: allFile(filter: {base: {glob: "*.jsonpatch.json"}}) {
    ...filecontent
  }
  baseline: allFile(filter: {base: {eq: "entitydatabase.json"}}) {
    ...filecontent
  }
}

fragment filecontent on FileConnection {
  edges {
    node {
      base
      name
      childRawCode {
        content
      }
    }
  }
}
`